// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000' || 'http://localhost:8000';

// const Testimonials = () => {
//   const [testimonials, setTestimonials] = useState([]);

//   useEffect(() => {
//     fetchTestimonials();
//   }, []);

//   const fetchTestimonials = async () => {
//     try {
//       const response = await axios.get(`${BACKEND_URL}/api/public/testimonials`);
//       setTestimonials(response.data);
//     } catch (error) {
//       console.error('Failed to fetch testimonials:', error);
//       // Fallback to mock data
//       setTestimonials([
//         {
//           id: '1',
//           quote: "TokoSprint made my online store setup incredibly simple and fast!",
//           author: "Alex Taylor",
//           role: "E-commerce Manager",
//           avatar_url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eaf_Team%20Image.avif"
//         },
//         {
//           id: '2',
//           quote: "The support team is always there to help when needed!",
//           author: "Jordan Casey",
//           role: "Customer Success",
//           avatar_url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eb8_Team%20Person%20Image%206.avif"
//         },
//         {
//           id: '3',
//           quote: "I launched my store in just hours, thanks to TokoSprint!",
//           author: "Sam Morgan",
//           role: "Marketing Specialist",
//           avatar_url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2ec1_Team%20Person%20Image%204.avif"
//         },
//         {
//           id: '4',
//           quote: "Fast and reliable, TokoSprint exceeded my expectations for e-commerce!",
//           author: "Skyler Lee",
//           role: "Product Designer",
//           avatar_url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2ec1_Team%20Person%20Image%204.avif"
//         }
//       ]);
//     }
//   };

//   // Duplicate testimonials for seamless loop
//   const duplicatedTestimonials = [...testimonials, ...testimonials];

//   return (
//     <section id="testimonials" className="py-20 px-6 bg-gradient-green-strong bg-tech-grid overflow-hidden">
//       <div className="max-w-7xl mx-auto">
//         <div className="text-center mb-16">
//           <p className="text-brand-green-600 text-sm font-bold mb-6 tracking-wide uppercase">Customer Testimonials</p>
//           <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight">Join Our Thriving E-Commerce Community Today</h2>
//           <p className="text-xl text-gray-600">Discover how our platform empowers entrepreneurs to launch their online stores effortlessly.</p>
//         </div>

//         {/* Infinite Scroll Container - Moving Right */}
//         <div className="relative">
//           <div className="testimonials-scroll-right">
//             <div className="flex gap-8">
//               {duplicatedTestimonials.map((testimonial, index) => (
//                 <div 
//                   key={`${testimonial.id}-${index}`}
//                   className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:scale-105 flex-shrink-0 w-80"
//                 >
//                   <div className="mb-6">
//                     <img 
//                       src={testimonial.avatar_url} 
//                       alt={testimonial.author} 
//                       className="w-16 h-16 rounded-full object-cover mb-4"
//                     />
//                     <p className="text-gray-700 mb-4 italic">"{testimonial.quote}"</p>
//                   </div>
//                   <div>
//                     <p className="font-bold text-gray-900">{testimonial.author}</p>
//                     <p className="text-sm text-gray-500">{testimonial.role}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {testimonials.length === 0 && (
//           <div className="text-center py-12 text-gray-500">
//             No testimonials available
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default Testimonials;

import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000' || 'http://localhost:8000';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/public/testimonials`);
      setTestimonials(response.data);
    } catch (error) {
      console.error('Failed to fetch testimonials:', error);
      // Fallback to mock data
      setTestimonials([
        {
          id: '1',
          quote: "TokoSprint made my online store setup incredibly simple and fast!",
          author: "Alex Taylor",
          role: "E-commerce Manager",
          avatar_url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eaf_Team%20Image.avif"
        },
        {
          id: '2',
          quote: "The support team is always there to help when needed!",
          author: "Jordan Casey",
          role: "Customer Success",
          avatar_url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eb8_Team%20Person%20Image%206.avif"
        },
        {
          id: '3',
          quote: "I launched my store in just hours, thanks to TokoSprint!",
          author: "Sam Morgan",
          role: "Marketing Specialist",
          avatar_url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2ec1_Team%20Person%20Image%204.avif"
        },
        {
          id: '4',
          quote: "Fast and reliable, TokoSprint exceeded my expectations for e-commerce!",
          author: "Skyler Lee",
          role: "Product Designer",
          avatar_url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2ec1_Team%20Person%20Image%204.avif"
        }
      ]);
    }
  };

  // Duplicate testimonials for seamless loop
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  return (
    // DIUBAH: Dihapus 'bg-gradient-green-strong bg-tech-grid'
    <section id="testimonials" className="py-20 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          {/* Badge ini sudah OK */}
          <p className="text-brand-green-500 text-sm font-bold mb-6 tracking-wide uppercase">Customer Testimonials</p>
          {/* DIUBAH: Teks judul diubah menjadi 'text-white' */}
          <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight text-white">Join Our Thriving E-Commerce Community Today</h2>
          {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
          <p className="text-xl text-gray-300">Discover how our platform empowers entrepreneurs to launch their online stores effortlessly.</p>
        </div>

        {/* Infinite Scroll Container - Moving Right */}
        <div className="relative">
          <div className="testimonials-scroll-right">
            <div className="flex gap-8">
              {duplicatedTestimonials.map((testimonial, index) => (
                <div 
                  key={`${testimonial.id}-${index}`}
                  // DIUBAH: 'bg-gray-50' diubah menjadi 'bg-black/30 backdrop-blur-lg border'
                  className="bg-black/30 backdrop-blur-lg border border-gray-700/50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:scale-105 flex-shrink-0 w-80"
                >
                  <div className="mb-6">
                    <img 
                      src={testimonial.avatar_url} 
                      alt={testimonial.author} 
                      className="w-16 h-16 rounded-full object-cover mb-4"
                    />
                    {/* DIUBAH: Teks quote diubah menjadi 'text-gray-200' */}
                    <p className="text-gray-200 mb-4 italic">"{testimonial.quote}"</p>
                  </div>
                  <div>
                    {/* DIUBAH: Teks author diubah menjadi 'text-white' */}
                    <p className="font-bold text-white">{testimonial.author}</p>
                    {/* DIUBAH: Teks role diubah menjadi 'text-gray-400' */}
                    <p className="text-sm text-gray-400">{testimonial.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {testimonials.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            No testimonials available
          </div>
        )}
      </div>
    </section>
  );
};

export default Testimonials;